var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{staticClass:"chart",attrs:{"options":_vm.chartOptions,"data":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }